module.exports = __webpack_public_path__ + "img/ab2e8c4.png";